import React, { useState } from "react";
import { ApiController } from "../../../../Utills/ApiController";
import { Message, MessageType } from "../../../../Utills/RestApiModels/MessageModel";

const ContactComponent: React.FC = () => {
    let ac = new ApiController();

    const [formData, setFormData] = useState<Message>({
        id: null,
        fullname: "",
        email: "",
        topic: MessageType["NONE"], // Domyślna wartość select
        content: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false); // Stan do śledzenia, czy formularz jest wysyłany
    const [submitStatus, setSubmitStatus] = useState<"success" | "error" | null>(null); // Stan dla wyniku wysyłki
    const [success, setSuccess] = useState(false);

    // Funkcja do obsługi zmian w polach formularza
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
        // Resetuj status wysyłki przy każdej zmianie
        setSubmitStatus(null);
    };

    // Funkcja do obsługi wysłania formularza
    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault(); // Zapobiega domyślnej akcji przeładowania strony

        setIsSubmitting(true); // Ustawiamy stan wysyłania
        setSuccess(false);

        // Walidacja prostych pól (można rozbudować)
        if (!formData.fullname || !formData.email || formData.topic === "NONE" || !formData.content) {
            setSubmitStatus("error");
            setIsSubmitting(false);
            alert("Proszę wypełnić wszystkie wymagane pola."); // Można użyć lepszego UI do wyświetlania błędów
            return;
        }

        try {
            ac.SendMessage(formData);
            setSuccess(true);
        } catch (error) {
            // Obsługa błędów sieciowych lub innych problemów z fetch
            console.error("Wystąpił błąd:", error);
            setSubmitStatus("error");
            alert("Wystąpił błąd sieci lub inny problem.");
        } finally {
            setIsSubmitting(false); // Zakończ stan wysyłania niezależnie od wyniku
        }
    };
    return (
        <section id="contact" className="py-32 relative">
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-20">
                    <h2 className="text-5xl sm:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">
                        Kontakt
                    </h2>
                    <p className="mt-4 text-xl text-gray-400">Porozmawiajmy o Twoich potrzebach</p>
                </div>

                <div className="flex flex-col items-center  max-w-6xl mx-auto">
                    {/*<div>*/}
                    {/*    <h3 className="text-3xl font-bold text-white mb-8">Skontaktuj się z nami</h3>*/}
                    {/*    <div className="space-y-6">*/}
                    {/*        <div className="flex gap-4">*/}
                    {/*            <div*/}
                    {/*                className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">*/}
                    {/*                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"*/}
                    {/*                     viewBox="0 0 24 24">*/}
                    {/*                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"*/}
                    {/*                          d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>*/}
                    {/*                </svg>*/}
                    {/*            </div>*/}
                    {/*            <div>*/}
                    {/*                <h4 className="font-semibold text-white mb-1">Email</h4>*/}
                    {/*                <p className="text-gray-400">kontakt@cageeeg.pl</p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}

                    {/*        <div className="flex gap-4">*/}
                    {/*            <div*/}
                    {/*                className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">*/}
                    {/*                <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"*/}
                    {/*                     viewBox="0 0 24 24">*/}
                    {/*                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"*/}
                    {/*                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>*/}
                    {/*                </svg>*/}
                    {/*            </div>*/}
                    {/*            <div>*/}
                    {/*                <h4 className="font-semibold text-white mb-1">Telefon</h4>*/}
                    {/*                <p className="text-gray-400">+48 123 456 789</p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}

                    {/*        <div className="flex gap-4">*/}
                    {/*            <div*/}
                    {/*                className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">*/}
                    {/*                <svg className="w-6 h-6 text-orange-500" fill="currentColor"*/}
                    {/*                     viewBox="0 0 24 24">*/}
                    {/*                    <path*/}
                    {/*                        d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>*/}
                    {/*                </svg>*/}
                    {/*            </div>*/}
                    {/*            <div>*/}
                    {/*                <h4 className="font-semibold text-white mb-1">LinkedIn</h4>*/}
                    {/*                <p className="text-gray-400">linkedin.com/company/cageeeg</p>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}

                    {/*        /!*<div className="flex gap-4">*!/*/}
                    {/*        /!*    <div*!/*/}
                    {/*        /!*        className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">*!/*/}
                    {/*        /!*        <svg className="w-6 h-6 text-orange-500" fill="currentColor" viewBox="0 0 24 24">*!/*/}
                    {/*        /!*            <path*!/*/}
                    {/*        /!*                d="M20.317 4.3698a16.7241 16.7241 0 00-2.567-2.567C15.667.9336 13.559 0 11.328 0 5.064 0 0 5.064 0 11.328c0 2.231.9336 4.339 1.8698 6.4302a16.7241 16.7241 0 002.567 2.567C6.527 23.0664 8.635 24 10.866 24c6.264 0 11.328-5.064 11.328-11.328 0-2.231-.9336-4.339-1.8698-6.4302zM19.503 15.171c.314-.525.602-1.062.875-1.611-.473.212-.951.413-1.435.603a23.7576 23.7576 0 01-.56-1.59 16.1016 16.1016 0 011.12-.577c.21-.615.387-1.247.531-1.893a23.5936 23.5936 0 01-1.172.409 15.8195 15.8195 0 01-.409-1.628 16.3754 16.3754 0 011.049-.31c.055-.466.09-.938.105-1.416a23.5083 23.5083 0 01-1.154.228 15.5661 15.5661 0 01-.228-1.65c.275-.021.549-.05.822-.087-.105-.487-.239-.963-.402-1.428-.28.07-.562.133-.847.188a15.3404 15.3404 0 01-.603-1.584c.21-.084.419-.173.626-.267a8.1144 8.1144 0 00-.91-1.484c-.23.138-.463.272-.699.401a15.0417 15.0417 0 01-.973-1.404c.161-.147.32-.297.476-.451a8.3214 8.3214 0 00-1.372-1.107c-.175.196-.354.389-.536.578a14.7104 14.7104 0 01-1.295-1.113c.108-.189.212-.38.313-.574-.511-.252-1.045-.462-1.598-.626.047.252.1.503.158.752a14.5372 14.5372 0 01-1.535-.74c.05-.223.095-.447.136-.672a8.1763 8.1763 0 00-1.747-.231c.03.259.066.518.108.775a14.4161 14.4161 0 01-1.65-.228c-.007-.238-.019-.476-.036-.714-.175.007-.349.018-.522.034-.152.014-.303.032-.453.053-.032.24-.057.48-.077.721a14.4995 14.4995 0 01-1.628.322c-.056-.252-.117-.503-.183-.752a8.1935 8.1935 0 00-1.611.875c.133.224.27.445.412.663a14.6369 14.6369 0 01-1.468.782c-.126-.21-.256-.418-.39-.623a8.2803 8.2803 0 00-1.107 1.372c.196.175.396.347.599.515a14.8534 14.8534 0 01-1.113 1.295c-.189-.107-.38-.21-.574-.31-.25.509-.459 1.04-.623 1.589.252.048.503.101.752.159a14.8081 14.8081 0 01-.74 1.535c-.224-.05-.448-.096-.673-.137a8.3447 8.3447 0 00-.227 1.744c.259.031.518.067.775.109a15.0417 15.0417 0 01-.228 1.65c-.238-.007-.476-.018-.714-.035a16.4609 16.4609 0 00.07.973c.245.015.49.035.734.06.077.532.172 1.058.285 1.578a16.8566 16.8566 0 01-.735.14c.133.523.294 1.034.483 1.532.238-.063.475-.13.71-.201a16.3016 16.3016 0 00.679 1.459c-.21.112-.417.228-.622.348.294.434.615.847.961 1.237.193-.145.383-.294.57-.446a16.9381 16.9381 0 001.074 1.197c-.147.161-.29.325-.43.492a8.211 8.211 0 001.237.961c.121-.21.238-.422.351-.636.457.259.928.497 1.413.714-.077.231-.149.464-.217.698.497.189 1.008.35 1.532.483.05-.245.094-.49.133-.736a17.2936 17.2936 0 001.593.287c.007.238.019.476.036.714.175-.007.349-.018.522-.034.152-.014.303-.032.453-.053.032-.24.058-.48.078-.721a17.0909 17.0909 0 001.585-.319c.063.252.131.503.204.752a8.3213 8.3213 0 001.565-.883 18.444 18.444 0 01-.406-.65c.518-.262 1.025-.543 1.518-.843.126.21.256.418.39.623a8.313 8.313 0 001.141-1.395 18.5602 18.5602 0 01-.623-.498c.399-.406.782-.827 1.148-1.263.189.108.38.211.574.31z"/>*!/*/}
                    {/*        /!*        </svg>*!/*/}
                    {/*        /!*    </div>*!/*/}
                    {/*        /!*    <div>*!/*/}
                    {/*        /!*        <h4 className="font-semibold text-white mb-1">Discord</h4>*!/*/}
                    {/*        /!*        <p className="text-gray-400"><a href={"https://discord.gg/EpJDJJHENh"}>discord.gg/EpJDJJHENh</a></p>*!/*/}
                    {/*        /!*    </div>*!/*/}
                    {/*        /!*</div>*!/*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                    <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10">
                        <h3 className="text-2xl font-bold text-white mb-6">Wyślij wiadomość</h3>
                        <form className="space-y-4" onSubmit={handleSubmit}>
                            <input
                                type="text"
                                name="fullname" // Dodaj atrybut 'name' zgodny z kluczem w stanie 'formData'
                                placeholder="Imię i nazwisko"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 transition-colors"
                                value={formData.fullname} // Kontroluj wartość pola za pomocą stanu
                                onChange={handleInputChange} // Reaguj na zmiany w polu
                                disabled={isSubmitting} // Wyłącz pole podczas wysyłania
                            />

                            <input
                                type="email"
                                name="email" // Dodaj atrybut 'name'
                                placeholder="Email"
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 transition-colors"
                                value={formData.email}
                                onChange={handleInputChange}
                                disabled={isSubmitting}
                            />

                            <select
                                name="topic" // Dodaj atrybut 'name'
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white focus:outline-none focus:border-orange-500 transition-colors appearance-none"
                                value={formData.topic}
                                onChange={handleInputChange}
                                disabled={isSubmitting}
                            >
                                <option className="bg-gray-900" value="NONE">
                                    Wybierz temat
                                </option>
                                <option className="bg-gray-900" value="TECH">
                                    Zapytanie techniczne
                                </option>
                                <option className="bg-gray-900" value="COOP">
                                    Współpraca
                                </option>
                                <option className="bg-gray-900" value="SUPPORT">
                                    Wsparcie
                                </option>
                                <option className="bg-gray-900" value="QUESTION">
                                    Inne
                                </option>
                            </select>

                            <textarea
                                name="content" // Dodaj atrybut 'name'
                                placeholder="Wiadomość"
                                rows={4}
                                className="w-full px-4 py-3 bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-500 focus:outline-none focus:border-orange-500 transition-colors resize-none"
                                value={formData.content}
                                onChange={handleInputChange}
                                disabled={isSubmitting}
                            ></textarea>

                            <button
                                type="submit"
                                className="w-full py-4 bg-gradient-to-r from-orange-400 to-orange-600 text-black font-semibold rounded-xl hover:shadow-lg hover:shadow-orange-500/25 transition-all duration-300 hover:scale-[1.02]"
                                disabled={isSubmitting} // Wyłącz przycisk podczas wysyłania
                            >
                                {isSubmitting ? "Wysyłanie..." : "Wyślij wiadomość"} {/* Zmień tekst przycisku podczas wysyłania */}
                            </button>

                            {/* Opcjonalnie: Wyświetl status wysyłki */}
                            {submitStatus === "success" && <p className="text-green-500">Wiadomość wysłana pomyślnie!</p>}
                            {submitStatus === "error" && <p className="text-red-500">Wystąpił błąd podczas wysyłania wiadomości.</p>}
                        </form>
                        {success && (
                            <div style={{ color: "green", marginTop: "1rem", fontWeight: 600 }}>
                                Wiadomość wysłana
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactComponent;
